import { httpClient } from "./httpClient"

export interface LeaderboardRecord {
  position: number
  wallet?: string
  points: number
  isCurrentUser?: boolean
}

export interface GetLeaderboardResponse {
  top: LeaderboardRecord[]
  refCode: string | null
}

async function getLeaderboard(request: {
  refCode: string | null
}): Promise<GetLeaderboardResponse> {
  const response = await httpClient.post<GetLeaderboardResponse>(
    "/leaderboard",
    request,
  )
  return response.data
}

async function verifyPoints(request: { room: string }): Promise<boolean> {
  const response = await httpClient.post<boolean>("/points/verify", request)
  return response.data
}

export const pointsApi = {
  getLeaderboard,
  verifyPoints,
}
